import { RadioGroupOption } from 'src/components/finalForm';

import { PrivacySettingsRequirementOptions } from './types';

export const VerificationPreferenceSettingsValues: RadioGroupOption[] = [
  {
    value: PrivacySettingsRequirementOptions.allowAll,
    label: PrivacySettingsRequirementOptions.allowAll,
  },
  {
    value: PrivacySettingsRequirementOptions.requireWithMyApprove,
    label: PrivacySettingsRequirementOptions.requireWithMyApprove,
  },
];
